(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.variant-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.disabled) return;
      var form = pill.closest('form');
      form.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('active'); });
      pill.classList.add('active');
      form.querySelector('[data-variant-input]').value = pill.dataset.variantId;

      var priceEl = form.parentElement.querySelector('[id^="product-price-"]');
      if (priceEl) priceEl.textContent = pill.dataset.variantPrice;

      var submitBtn = form.querySelector('button[type="submit"]');
      var label = submitBtn.querySelector('[data-add-to-cart-text]');
      if (pill.dataset.variantAvailable === 'true') {
        submitBtn.disabled = false;
        label.textContent = 'Add to Bag — ' + pill.dataset.variantPrice;
      } else {
        submitBtn.disabled = true;
        label.textContent = 'Sold Out';
      }
    });
  });
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
  var scroller = gallery.querySelector('[data-gallery-scroll]');
  var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
  if (!scroller || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var slide = scroller.children[parseInt(thumb.dataset.index, 10)];
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    });
  });

  var syncActiveThumb = function () {
    var index = Math.round(scroller.scrollLeft / scroller.clientWidth);
    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('active', i === index);
    });
  };

  var scrollTimeout;
  scroller.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(syncActiveThumb, 100);
  });
});

  } catch(e) { console.error(e); }
})();
})();
